export class Comment{
    comment: string;
    status:string;
    puid: string;
    timeStamp: Date;
    plateId?: string;
    runId?: string;

    public static readonly GENERATED_BY_SYSTEM_TAG = "Generated by system";
}
